const CountUp = require('countup')

let initOnceCount = true

export const initCountUp = () => {
  const targets = document.querySelectorAll('.statistics-blocks')
  initOnceCount = true

  if (targets) {
    let options = {
      rootMargin: '0px',
      threshold: [0.1]
    }

    let observer = new IntersectionObserver(callback, options);

    for (var i = targets.length - 1; i >= 0; i--) {
      observer.observe(targets[i])
    }
  }
}

const initCounterElement = () => {
  const countElements = document.querySelectorAll('.num')

  const options = {
    useEasing: true,
    useGrouping: true,
    separator: ','
  }

  for (var i = countElements.length - 1; i >= 0; i--) {
    let numAnim = new CountUp(countElements[i], 0, countElements[i].innerText, 0, 5, options)
    numAnim.start()
  }
}

let callback = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting && initOnceCount) {
      initCounterElement();
      initOnceCount = false;
    }
  });
};
